import { render, staticRenderFns } from "./emphasis.vue?vue&type=template&id=3d3893fb&scoped=true"
import script from "./emphasis.vue?vue&type=script&lang=js"
export * from "./emphasis.vue?vue&type=script&lang=js"
import style0 from "./emphasis.vue?vue&type=style&index=0&id=3d3893fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3893fb",
  null
  
)

export default component.exports